<script>
import { notify } from '@/helpers/notify' 
import {
  required
} from "vuelidate/lib/validators";

export default {
  name: 'CreateUrun',
  props:[
    "list"
  ],
  data() {
        return {
            groups:[
                { name:"Anten", code:"an",},
                { name:"Kablo", code:"ka"},
                { name:"Modem", code:"mo"},
                { name:"Sarf Malzeme", code:"sm"},
            ],
            groupList:[],
            form:{
                unit:'adet',
                name:'',
                group_id:'',
                price:0
            },
            submitted: false,
            seri_no:'',
            adet:1,
            loading:false,
        };  
    },
    watch:{
        list(props){
            this.form = props
        }
    },
    validations: {
        form: {
            unit: { required },
            name: { required },
            group_id: { required },
            price: { required },
        },
    },
    methods: {
        handleSubmit() {
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            } 

            if(this.form.id)
                this.update();
            else
                this.create();
          
            this.submitted = false;
        },
        create(){
            this.$http.post('/stock/product/store', { ...this.form})
                .then(resp => {
                    if(!resp.data.error) this.form = {};

                    this.$emit('loadItems');
                    return notify.success(resp.data.message)
                })
        },
        update(){
            this.$http.put('/stock/product/' + this.form.id ,  { ...this.form})
                .then(resp => {
                    this.$emit('loadItems');
                    return notify.success(resp.data.message)
                })
        },
        remove(id){
            this.$http.delete('/stock/product/' + id)
                .then(resp => {
                    if(resp.data.code !==  100)  return notify.error(resp.data.message)
                    this.$emit('loadItems');
                    return notify.success(resp.data.message)
                })
        },
        close(){
            this.$parent.$bvModal.hide('modal-urun')
        },
  },
};
</script>

<template>
  <b-modal 
        id="modal-urun"
        title="Ürün Ekleme/Güncelleme"  
        no-close-on-backdrop 
        hide-footer>

    <form @submit.prevent="handleSubmit" @keydown.enter.prevent>
        <div class="row mb-2">
            <label class="col-sm-4 col-form-label" for="groups">Ürün Grubu</label>
            <div class="col-sm-8">
                <select 
                    class="form-control form-select"  
                    :class="{
                        'is-invalid': submitted && $v.form.group_id.$error,
                    }" 
                    v-model="form.group_id">
                    <option value="">Seçiniz</option>
                    <option :value="group.code" v-for="(group,i) in groups" :key="i">{{ group.name }}</option>
                </select>
                <div
                    v-if="submitted && !$v.form.group_id.required"
                    class="invalid-feedback"
                >
                Bu alanı doldurmak zorunludur.
                </div>
            </div>
        </div>
        <div class="row mb-2">
            <label class="col-sm-4 col-form-label" for="tanim">Tanım</label>
            <div class="col-sm-8">
                <input
                    id="tanim"
                    v-model="form.name"
                    type="text"
                    class="form-control"
                    placeholder="Tanım"
                    :class="{'is-invalid': submitted && $v.form.name.$error}"
                />
                <div
                    v-if="submitted && !$v.form.name.required"
                    class="invalid-feedback">
                    Bu alanı doldurmak zorunludur.
                </div>
            </div>
        </div>
        <div class="row mb-2">
            <label class="col-sm-4 col-form-label" for="unit">Birim</label>
            <div class="col-sm-8">
                <select 
                    class="form-control form-select"  
                    v-model="form.unit"
                    :class="{'is-invalid': submitted && $v.form.unit.$error}">
                    <option value="adet">Adet</option>
                    <option value="metre">Metre</option>
                </select>
                <div
                    v-if="submitted && !$v.form.unit.required"
                    class="invalid-feedback"
                >
                Bu alanı doldurmak zorunludur.
                </div>
            </div>
        </div>
        <div class="row mb-2">
            <label class="col-sm-4 col-form-label" for="price">Satış Fiyatı</label>
            <div class="col-sm-8">
                 <input
                    id="price"
                    v-model="form.price"
                    type="text"
                    class="form-control"
                    placeholder="Satış Fiyatı"
                    :class="{'is-invalid': submitted && $v.form.price.$error}"
                />
                <div
                    v-if="submitted && !$v.form.price.required"
                    class="invalid-feedback">
                    Bu alanı doldurmak zorunludur.
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-between mt-3">
            <div>
            <b-button variant="danger"  v-if="form.id" @click="remove(form.id)">Sil</b-button>
            </div>
            <div class="d-flex justify-content-between">
                <b-button variant="light" @click="close()">Vazgeç</b-button>
                <b-button 
                    v-if="form.id"
                    type="submit" 
                    variant="warning" 
                    class="ms-1"
                    >Güncelle
                </b-button>
                <b-button 
                    v-else
                    type="submit" 
                    variant="success" 
                    class="ms-1"
                    >Oluştur
                </b-button>
            </div>
        </div>
    </form>
</b-modal>
</template>  